
import { Component, Watch, Vue } from 'vue-property-decorator'

import { MenuToggleButton } from '@mg/micro/vue2/MenuToggleButton'
import type { MenuToggleButtonTranslations } from '@mg/micro/vue2/MenuToggleButton'
import { Shops } from '~/config/shops'

import {
  GET_LOCAL_MENU_VISIBILITY,
  SET_HEADER_VISIBILITY,
} from '~/graphql/gqlLocal/localHeader'
import { GQLLocalHeader } from '~/graphql/__generated__/interfacesLocal'
import { GtmEventTypes } from '~/utils/tracking/gtm'

@Component({
  apollo: {
    header: {
      query: GET_LOCAL_MENU_VISIBILITY,
    },
  },
  components: {
    MenuToggleButton,
  },
})
export default class HeaderMenuToggleButton extends Vue {
  header: GQLLocalHeader

  setMenuVisibility(isVisible: boolean) {
    this.$apollo.mutate({
      mutation: SET_HEADER_VISIBILITY,
      variables: {
        isMenuVisible: isVisible,
        isSearchVisible: false,
      },
    })
  }

  get menuIsVisible() {
    return this.header?.menuIsVisible ?? false
  }

  get isSlovenia() {
    return this.$shopConfig.shopId === Shops.SI10SI
  }

  @Watch('header.menuIsVisible')
  onIsVisibleChange() {
    if (this.$resize.isDesktop) {
      return
    }

    if (this.menuIsVisible) {
      document.body.classList.add('lock-scroll')
    } else {
      document.body.classList.remove('lock-scroll')
    }
  }

  get translations(): MenuToggleButtonTranslations {
    return {
      menu: 'Menu',
      close: this.$t('common.close') as string,
    }
  }

  toggleMainMenuOpen() {
    const isVisible = this.header.menuIsVisible
    this.setMenuVisibility(!isVisible)
    this.gaEventClick(!isVisible ? 'Open' : 'Close')
  }

  gaEventClick(eventLabel: string) {
    this.$pushAnalyticsEvent(GtmEventTypes.EventFire, {
      eventAction: 'Mobile navigation',
      eventCategory: 'Navigation',
      eventLabel,
      eventNonInteractionFlag: true,
      eventValue: 1,
    })
  }
}
